module.exports = __webpack_public_path__ + "static/media/plane.0b1b96a3.svg";